import { OrderStatus } from '@nemuru-eng/js-api-client';
import React from 'react';

import { StatusTagType } from '../../../../../config/types';
import { StatusTag } from '../StatusTag';

export const OrderStatusTag: React.FC<{ status: OrderStatus }> = ({ status }) => {
  const getStatusTagProps = (): React.ComponentProps<typeof StatusTag> => {
    switch (status) {
      case OrderStatus.PENDING:
        return {
          type: StatusTagType.INFO,
          labelTextId: 'PENDING',
          colorType: 'dark',
        };
      case OrderStatus.CONFIRMED:
        return {
          type: StatusTagType.SUCCESS,
          labelTextId: 'CONFIRMED',
        };
      case OrderStatus.REJECTED:
        return {
          type: StatusTagType.ERROR,
          labelTextId: 'REJECTED',
        };
      case OrderStatus.CONFIRMATION_REQUIRED:
        return {
          type: StatusTagType.DEFAULT,
          labelTextId: 'CONFIRMATION_REQUIRED',
        };
      case OrderStatus.BLOCKED_PENDING_LENDER:
        return {
          type: StatusTagType.DEFAULT,
          labelTextId: 'BLOCKED_PENDING_LENDER',
        };
    }
  };

  const statusTagProps = getStatusTagProps();
  return <StatusTag {...statusTagProps}/>;
};
